// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-box_ServiceBox__bq7n- {
    width: 100%;
    height: 109px;
    max-width: 170px;
    margin-top: 10px;
}

.service-box_ServiceShape__iM65i {
    width: 35px;
    height: 70px;
    margin-left: 21px;
    position: relative;
    border-radius: 100px;
    margin-bottom: -19px;
    float: left !important;
    border: 1px solid #D6E5B8;
    background-color: #191A17;
}

.service-box_ServiceIconBox__UYmFg {
    width: 100%;
    height: 45px;
    display: flex;
    max-width: 45px;
    flex-wrap: wrap;
    overflow: hidden;
    margin-top: 37px;
    margin-left: -17px;
    border-radius: 50%;
    position: relative;
    align-items: center;
    margin-bottom: -270px;
    float: left !important;
    justify-content: center;
    border: 1px solid #D6E5B8;
    background-color: #474D3D;
}

.service-box_ServiceTittleBox__Gll3P {
    height: 55px;
    display: flex;
    flex-wrap: wrap;
    border-radius: 5px;
    text-align: center;
    justify-content: center;
    background-color: #474D3D;
}

.service-box_ServiceTittleBox__Gll3P p {
    margin: 0;
    font-size: 10px;
    margin-top: 35px;
    color: #FFFFFF;
    font-family: "Gothic";
}

@media (min-width: 1200px) {
    .service-box_ServiceBox__bq7n- {
        width: 33.33%;
        height: 175px;
        max-width: 415px;
        text-align: right;
        margin-bottom: 50px;
        vertical-align: top;
        display: inline-block;
        float: none !important;
        margin-right: 0 !important;
    }

    .service-box_ServiceShape__iM65i {
        width: 100%;
        height: 140px;
        max-width: 70px;
        position: relative;
        border-radius: 100px;
        margin-bottom: -19px;
        border: 3px solid #D6E5B8;
    }

    .service-box_ServiceIconBox__UYmFg {
        width: 100%;
        height: 90px;
        max-width: 90px;
        margin-top: 80px;
        margin-left: -40px;
        border: 3px solid #D6E5B8;
    }

    .service-box_ServiceTittleBox__Gll3P {
        width: 100%;
        height: 50px;
        max-width: 340px;
        margin-top: -105px;
        text-align: center;
        border-radius: 10px;
        align-items: center;
    }
    .service-box_ServiceTittleBox__Gll3P p {
        margin: 0;
        font-size: 17px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/service-box/service-box.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI;QACI,aAAa;QACb,aAAa;QACb,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;QACnB,qBAAqB;QACrB,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,aAAa;QACb,eAAe;QACf,kBAAkB;QAClB,oBAAoB;QACpB,oBAAoB;QACpB,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,eAAe;IACnB;AACJ","sourcesContent":[".ServiceBox {\r\n    width: 100%;\r\n    height: 109px;\r\n    max-width: 170px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.ServiceShape {\r\n    width: 35px;\r\n    height: 70px;\r\n    margin-left: 21px;\r\n    position: relative;\r\n    border-radius: 100px;\r\n    margin-bottom: -19px;\r\n    float: left !important;\r\n    border: 1px solid #D6E5B8;\r\n    background-color: #191A17;\r\n}\r\n\r\n.ServiceIconBox {\r\n    width: 100%;\r\n    height: 45px;\r\n    display: flex;\r\n    max-width: 45px;\r\n    flex-wrap: wrap;\r\n    overflow: hidden;\r\n    margin-top: 37px;\r\n    margin-left: -17px;\r\n    border-radius: 50%;\r\n    position: relative;\r\n    align-items: center;\r\n    margin-bottom: -270px;\r\n    float: left !important;\r\n    justify-content: center;\r\n    border: 1px solid #D6E5B8;\r\n    background-color: #474D3D;\r\n}\r\n\r\n.ServiceTittleBox {\r\n    height: 55px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    border-radius: 5px;\r\n    text-align: center;\r\n    justify-content: center;\r\n    background-color: #474D3D;\r\n}\r\n\r\n.ServiceTittleBox p {\r\n    margin: 0;\r\n    font-size: 10px;\r\n    margin-top: 35px;\r\n    color: #FFFFFF;\r\n    font-family: \"Gothic\";\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .ServiceBox {\r\n        width: 33.33%;\r\n        height: 175px;\r\n        max-width: 415px;\r\n        text-align: right;\r\n        margin-bottom: 50px;\r\n        vertical-align: top;\r\n        display: inline-block;\r\n        float: none !important;\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    .ServiceShape {\r\n        width: 100%;\r\n        height: 140px;\r\n        max-width: 70px;\r\n        position: relative;\r\n        border-radius: 100px;\r\n        margin-bottom: -19px;\r\n        border: 3px solid #D6E5B8;\r\n    }\r\n\r\n    .ServiceIconBox {\r\n        width: 100%;\r\n        height: 90px;\r\n        max-width: 90px;\r\n        margin-top: 80px;\r\n        margin-left: -40px;\r\n        border: 3px solid #D6E5B8;\r\n    }\r\n\r\n    .ServiceTittleBox {\r\n        width: 100%;\r\n        height: 50px;\r\n        max-width: 340px;\r\n        margin-top: -105px;\r\n        text-align: center;\r\n        border-radius: 10px;\r\n        align-items: center;\r\n    }\r\n    .ServiceTittleBox p {\r\n        margin: 0;\r\n        font-size: 17px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ServiceBox": `service-box_ServiceBox__bq7n-`,
	"ServiceShape": `service-box_ServiceShape__iM65i`,
	"ServiceIconBox": `service-box_ServiceIconBox__UYmFg`,
	"ServiceTittleBox": `service-box_ServiceTittleBox__Gll3P`
};
export default ___CSS_LOADER_EXPORT___;
